export default __webpack_public_path__ + "static/media/blob1.b911e4f9.svg";